export default "__VITE_ASSET__69mW5RDf__"